<mat-toolbar class="p-0 mat-elevation-z1 autoverse-toolbar" style="box-shadow: none !important;">
    <div  class=""  fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div *ngIf="!isMobile" class="h-100-p" fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center" style="width: 55% !important;">

           
            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div class="delivery-header">
                <div class="delivery-info" >
                    <img src="../../../../assets/images/flash-new-image.svg">
                  <span class="deliveryTime" [ngClass]="{'deliveryTimeMobile': isMobile}">Fast Delivery (90 minutes)</span>
                </div>
            </div>
            <div class="SearchBarContainer" (click)="toggleSearch()" [ngClass]="{'SearchBarContainerMobile': isMobile}">
                <div class="SearchBarButton">
                  <div class="SearchBarIcon">
                    <i class="material-icons">search</i>
                  </div>
                  <!-- <img class = "toolbarmenuimg"*ngIf="showSearchBarMenu " src="../../../../assets/images/searchbarmenu.png" (click)="aspAddItem()"> -->

                  <div class="SearchBarPlaceholder">
                    <div class="SearchBarAnimation" *ngIf="!isInputVisible">
                      <div id="animationText-1" class="SearchBarAnimationText">Search By "Part Name"</div>
                      <div id="animationText-2" class="SearchBarAnimationText">Search By "Part Number"</div>
                      <div id="animationText-3" class="SearchBarAnimationText">Search By "Brand"</div>
                      <div id="animationText-4" class="SearchBarAnimationText">Search By "Category"</div>
                      <!-- <mat-toolbar>
                        <button mat-icon-button (click)="aspAddItem()">
                          <mat-icon>menu</mat-icon>
                        </button>
                      </mat-toolbar> -->
                      
                      <!-- Add Item Sidebar -->
                      
                    </div>
                    <div *ngIf="isInputVisible" class="SearchInputContainer" (click)="$event.stopPropagation()">
                        <input
                          type="text"
                          placeholder="Type your search"
                          class="SearchInput"
                          [(ngModel)]="searchText"
                          (input)="filterSuggestions()"
                          (click)="toggleSearch()"
                        >
                        <button (click)="clearSearch($event)" class="button">
                          <i class="material-icons">clear</i>
                        </button>
                
                        <!-- Suggestions Dropdown -->
                        
                      
                    </div>
                    <div #dropdown class="suggestions" *ngIf="suggestions.length > 0">
                          <div *ngFor="let suggestion of suggestions; let i = index" (click)="selectSuggestion(suggestion)">
                            <i class="material-icons" *ngIf="isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">access_time</i>
                            <i class="material-icons" *ngIf="!isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">search</i>
                            <span [innerHTML]="getHighlightedText(suggestion.value, searchText)"></span>

                          </div>
                        </div>
                  </div>
                  <!-- <img class="toolbarmenuimg" *ngIf="showSearchBarMenu" src="../../../../assets/images/searchbarmenu.png"(click)="aspAddItem()"> -->
                <img class="toolbarmenuimg" *ngIf="showSearchBarMenu" src="../../../../assets/images/searchbarmenu.png"style="width: 6%; height: 26px;float: right;" (click)="aspAddItem()">
                </div>
            </div>
            <!-- <button class="magic-btn animate-cta" (click)="loadInstantDetails()" >
            ✨ Get Magic Quote ✨
            </button> -->
        </div> 
                <!-- Mobile  -->
        <div *ngIf="isMobile" class="mobile-menu">
            <button mat-icon-button class="navbar-toggle-button" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="logo" (click)="goToHome()">
                <img class="logo-icon" src="../../../../assets/images/logos/pitstop-white.png" alt="">
                <!-- <span class="logo-text">AUTOVERSE</span> -->
            </div>
            <div *ngIf="!isHomePage && !isMobile" (click)="$event.stopPropagation()"  class="searchMat">
                <span (click)="goToSearchPage($event)">
                <mat-icon>search</mat-icon>
            </span>
                </div>

            <!-- Build button to trigger garage menu -->
            <button mat-button [matMenuTriggerFor]="garageMenu" class="garage-selected" *ngIf="garages" (click)="loadorderdetails()" id="toolbarRef">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <!-- <mat-icon class="garage-icon-mobile-view">build</mat-icon> -->
                     <img src="../../../../assets/images/Frame-man-icon.png">
                    <!-- <span class="ml-8">Garage</span> -->
                </div>
            </button>
            <!-- <button class="magic-btn animate-cta" (click)="loadInstantDetails()" >
            ✨
            </button> -->

            <!-- Garage selection menu -->
            <mat-menu #garageMenu="matMenu" [overlapTrigger]="false" *ngIf="!isMobile">
                <button mat-menu-item (click)="loadorderdetails()">
                    <div class="garage-name">{{spareSelectedGarageName}}</div>      
                </button>
            </mat-menu>


            <!-- <div class="mywallet"  *ngIf=" roleType === 'part_manager' || roleType === 'owners' || roleType === 'autoverse_employee'">
                <button class="mywalletbtn" (click)="openSidebar()" >
                    <img src="../../../../assets/images/Frame-wallet-image.png" class="mywalletimg" alt="Wallet Icon">
                </button>
            </div> -->

            <!-- <div class="cart_btn_mobile">                
                <button class="open_btn_mobile" (click)="openCart()">
                    <mat-icon class="cart-icon-mobile-view">shopping_cart</mat-icon>
                    <div class="cart_count_mobile"><div *ngIf="cartCount > 0" class="cart_count">{{cartCount}}</div></div>
                </button>
            </div> -->
        </div>
        <!-- Change Garage -->
         <div class="last-four-divs">
            <button id="toolbarRef" *ngIf="!isMobile && garages" class="garage-selected" (click)="loadorderdetails()">
                <!-- <div class="garage-icon"><mat-icon>build</mat-icon></div>   -->
                <img src="../../../../assets/images/Frame-man-icon.png">
                <div class="garage-name">{{spareSelectedGarageName}}</div>      
            </button>
        <div class="last-three-divs">
            <div class="last-divs" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
                <div *ngIf="!isMobile" fxHide.gt-sm class="toolbar-separator"></div>
                <!-- <button fxHide.gt-sm mat-icon-button (click)="openSearch()" class="fuse-search-bar-expander" aria-label="Expand Search Bar">
                    <mat-icon class="s-24 secondary-text">search</mat-icon>
                </button> -->
                
                <!-- Help Us Improve -->
                <!-- Desktop -->
                <div class="help-us-know-button-wrapper" *ngIf="!isMobile">
                <button class="help-us-know-button" (click)="openHelpUsKnowSidebar()">
                    <div class="help-us-know-icon">
                        <!-- <img class="icon-circle" src="../../../../assets/images/help-us-improve-praying-icon.png"> -->
                        <div class="icon-circle">🙏</div>
                        <span class="help-us-know-tooltip">Help Us Improve</span>
                    </div>
                </button>
                </div>

                <!-- Mobile -->
                <div class="help-us-know-button-wrapper" *ngIf="isMobile">
                <button class="help-us-know-button" (click)="openHelpUsKnowSidebar()">
                    <div class="help-us-know-icon">
                    <div class="icon-circle">🙏</div>
                    <span class="help-us-know-tooltip">Help Us Improve</span>
                    </div>
                </button>
                </div>

                <!-- My Autoscore -->
                <!-- Desktop -->
                <div class="autoscore-button-wrapper" *ngIf="!isMobile">
                <button class="autoscore-button" (click)="openAutoscoreSidebar()">
                    <div class="star-icon">
                    <img src="../../../../assets/images/Rectangle-star-toolbar.png" class="star-bg" alt="star background" />
                    <img src="../../../../assets/images/rectangle-toolbar-star.png" class="star-inner" alt="star icon" />
                    <div *ngIf="autoscoreValue > 0" class="autoscore-badge">{{ autoscoreValue }}</div>
                    <span class="autoscore-tooltip">My Autoscore</span>
                    </div>
                </button>
                </div>

                <!-- Mobile -->
                <div class="autoscore-button-wrapper" *ngIf="isMobile">
                <button class="autoscore-button" (click)="openAutoscoreSidebar()">
                    <div class="star-icon">
                    <img src="../../../../assets/images/Rectangle-star-toolbar.png" class="star-bg" alt="star background" />
                    <img src="../../../../assets/images/rectangle-toolbar-star.png" class="star-inner" alt="star icon" />
                    <div *ngIf="autoscoreValue > 0" class="autoscore-badge">{{ autoscoreValue }}</div>
                    <span class="autoscore-tooltip">My Autoscore</span>
                    </div>
                </button>
                </div>


                <!-- Wallet -->
                <div *ngIf="!isMobile">
                    <!-- <div
                        class="mywallet"
                        *ngIf="
                        roleType === 'part_manager' ||
                        roleType === 'owners' ||
                        roleType === 'autoverse_employee'
                        "
                    >
                        <button
                        class="mywalletbtn"
                        (click)="openSidebar()"
                        style="background-color: #d7f5fc; color: #144579; font-weight: bold;display: flex;height: 41px;"                   >
                        <img src="../../../../assets/images/Frame-wallet-image.png" class="mywalletimg" alt="Wallet Icon">
                        <div class="left">
                            <div class="wallet_count_num">
                            <div *ngIf="availableWalletBalance > 0">
                                <div class="right-amount-carts-amount">My Wallet</div>
                                <div class="right-amount-carts">
                                ₹{{ availableWalletBalance }}
                                </div>
                            </div>
                            <div *ngIf="availableWalletBalance <= 0">
                                My Wallet
                            </div>
                            </div>
                        </div>
                        </button>
                    </div> -->
                    <!-- Desktop -->
                    <div *ngIf="!isMobile && (roleType === 'part_manager' || roleType === 'owners' || roleType === 'autoverse_employee')" class="wallet-tooltip-wrapper">
                        <button class="wallet-button" (click)="openSidebar()">
                            <div class="wallet-icon">
                                <img src="../../../../assets/images/Rectangle-star-toolbar.png" class="wallet-bg" alt="background" />
                                <img src="../../../../assets/images/Frame-wallet-image.png" class="wallet-inner" alt="wallet icon" />
                                <div *ngIf="availableWalletBalance > 0" class="wallet-badge">₹{{ availableWalletBalance }}</div>
                            </div>
                            <div class="wallet-tooltip">My Wallet</div>
                        </button>
                    </div>

                    <!-- Mobile -->


                </div>
                


                <!-- <div class="toolbar-separator"></div> -->
            
                <!-- Language Switcher -->
                <!-- <img class="translate-img" [matMenuTriggerFor]="menu" src="{{translateImg}}" />
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngFor="let language of translate.getLangs()" (click)="translateLanguageTo(language)">
                        <img *ngIf="language=='en'" src="{{langSwitchImg[0].en}}" />
                        <img *ngIf="language=='hi'" src="{{langSwitchImg[0].hi}}" />
                    </button>
                </mat-menu> -->
                <!-- <select #selLang (change)="translateLanguageTo(selLang.value)">
                    <option *ngFor="let language of translate.getLangs()" [value]="language">{{ language }}</option>
                </select> -->
                <!-- <div class="toolbar-separator"></div> -->
                <!-- End Language Switcher -->

                <!-- Cart  -->




                <!-- <div class="cart_btn">
                    <div class="count_notified">
                        <p class="cart_count_num">{{cartCount}}</p>
                    </div>
                    <button class="open_btn" (click)="openCart()">
                        <mat-icon>shopping_cart</mat-icon>My Cart
                    </button>
                </div>  -->

                <!-- <div class="cart_btn" *ngIf="isItemList" >
                    
                    <button class="open_btn" (click)="isFavorite()" style="margin: 0px;margin-right: -12px;">
                        <mat-icon>favorite</mat-icon>
                        <div class="left" style="padding: 0px 3px 0px 0px;">
                            
                            <div class="fev_count_num" style="text-align: left;">
                                <div *ngIf="fevCount > 0">
                                    {{fevCount}} items
                                    <div class="right-amount-carts">
                                        Added to Request
                                    
                                    </div>
                                </div>
                                <div *ngIf="fevCount <= 0">
                                My Wishlist
                                </div>
                            </div>
                        </div>
                    </button>
                </div> -->



        <div class="wishlist_btn" *ngIf="isItemList">
            <button class="wishlist_open_btn" (click)="isFavorite()">
                <div class="wishlist_icon">
                <img src="../../../../assets/images/Rectangle-star-toolbar.png" class="wishlist-bg" alt="wishlist background" />
                <mat-icon class="wishlist-inner">favorite</mat-icon>

                <!-- New UI badge (visible) -->
                <!-- <div class="wishlist-badge">{{ fevCount }} items</div> -->

                <!-- Tooltip -->
                <div class="wishlist-tooltip">My Request Wishlist</div>

                <div class="autoscore-badge1" style="display : none" >
                    <div *ngIf="fevCount > 0">{{ fevCount }} items
                    </div>

                </div>
                </div>
            </button>
        </div>




                    
                <!-- Cart -->
                <!-- <div class="cart_btn" *ngIf="!isMobile">
                    
                    <button class="open_btn" (click)="openCart()">
                        <mat-icon>shopping_cart</mat-icon>
                        <div class="left">
                            
                            <div class="cart_count_num">
                                <div *ngIf="cartCount > 0">
                                    {{cartCount}} items
                                    <div class="right-amount-carts">
                                        ₹{{cartGrandTotal + shippingCharges | number:'1.2-2'}}
                                    
                                    </div>
                                </div>
                                <div *ngIf="cartCount <= 0">
                                    My Cart
                                </div>
                            </div>
                        </div>
                    </button>
                </div> -->
                                    <div *ngIf="isMobile && (roleType === 'part_manager' || roleType === 'owners' || roleType === 'autoverse_employee')" class="wallet-tooltip-wrapper">
                        <button class="wallet-button" (click)="openSidebar()">
                            <div class="wallet-icon">
                                <img src="../../../../assets/images/Rectangle-star-toolbar.png" class="wallet-bg" alt="background" />
                                <img src="../../../../assets/images/Frame-wallet-image.png" class="wallet-inner" alt="wallet icon" />
                                <div *ngIf="availableWalletBalance > 0" class="wallet-badge">₹{{ availableWalletBalance }}</div>
                            </div>
                            <div class="wallet-tooltip">My Wallet</div>
                        </button>
                    </div>
                <!-- MOBILE CART BUTTON -->
                <div class="cart-btn-mobile" *ngIf="isMobile">
                    <div class="wallet-tooltip-wrapper">
                        <button class="cart-button" (click)="openCart()">
                            <div class="icon-wrapper">
                            <!-- background circle -->
                            <div class="icon-bg"></div>
                            <!-- cart icon -->
                            <img src="../../../../assets/images/cart_new-image.png" class="cart-icon" alt="cart" />

                            <!-- cart count -->
                            <div *ngIf="cartCount > 0" class="wallet-badge-cart-mobile">
                                {{ cartCount }}
                            </div>
                            </div>
                        </button>
                        <div class="wallet-tooltip" *ngIf="!isMobile" style="padding: 0;bottom: -50px;">My Cart</div>
                    </div>
                </div>

                <!-- DESKTOP CART BUTTON -->


                <!-- <div class="toolbar-separator"></div>  -->
                <!-- Cart End -->






                
                <!-- <button mat-button [matMenuTriggerFor]="userMenu" class="user-button" style=" margin-right: 10px;">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <img class="avatar mr-0 mr-sm-16" [src]="userData.img" 
                            onerror="this.onerror=null;this.src='https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png'">
                        <span class="username mr-12" fxHide fxShow.gt-sm>{{ userData.name }}</span>
                        <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                    </div>
                </button>

                <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                    <button mat-menu-item (click)="openProfile()">
                        <mat-icon>account_circle</mat-icon>
                        <span>Profile</span>
                    </button>
                    <button mat-menu-item class="" (click)="logout()">
                        <mat-icon>exit_to_app</mat-icon>
                        <span>Logout</span>
                    </button>
                    <button mat-menu-item [matMenuTriggerFor]="helpSection">
                        <mat-icon>help_outline</mat-icon>
                        <span>Help</span>
                    </button>
                </mat-menu>
                <mat-menu #helpSection="matMenu" [overlapTrigger]="false">
                    <div class="help_class">
                        <h4 class="helo_hedng">HELP</h4>
                        <hr>
                        <div class="email_help">
                            <p class="mail_sect">
                                <mat-icon>mail</mat-icon>
                            </p>
                            <p class="mail_sect"><a href="mailto:garage-help@getpitstop.com">garage-help@getpitstop.com</a></p>
                        </div>
                    </div>
                </mat-menu>
                <div class="toolbar-separator" fxHide.lt-md></div> -->

                
                <!-- <button mat-button fxHide.lt-md class="h-64 w-64" *ngIf="!isfullscreen" (click)="openFullscreen()">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <mat-icon class="s-32">fullscreen</mat-icon>
                    </div>
                </button>
                <button mat-button fxHide.lt-md class="h-64 w-64" *ngIf="isfullscreen" (click)="closeFullscreen()">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <mat-icon class="s-32">fullscreen_exit</mat-icon>
                    </div>
                </button> -->
                <!-- <div class="toolbar-separator"></div>

                <button mat-button fxHide fxShow.gt-xs
                        class="language-button"
                        [matMenuTriggerFor]="languageMenu">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.png'">
                        <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
                    </div>
                </button>

                <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

                    <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                        <span fxLayout="row" fxLayoutAlign="start center">
                            <img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
                            <span class="iso">{{lang.title}}</span>
                        </span>
                    </button>

                </mat-menu>

                <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

                <button mat-icon-button
                        class="quick-panel-toggle-button"
                        (click)="toggleSidebarOpen('quickPanel')"
                        aria-label="Toggle quick panel">
                    <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
                </button>

                <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

                <button mat-icon-button class="navbar-toggle-button"
                        *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                    <mat-icon class="secondary-text">menu</mat-icon>
                </button> -->
            </div>
            
        </div>
        <div class="cart-padd" *ngIf="!isMobile">
                    <div class="cart-btn-desktop" *ngIf="!isMobile">
                    <div class="wallet-tooltip-wrapper">
                        <button class="cart-button" (click)="openCart()">
                        <!-- <mat-icon class="cart-icon">shopping_cart</mat-icon> -->
                            <img src="../../../../assets/images/cart_new-image.png">
                            <div class="cart-new-class">
                                <div class="cart_count_num">
                                    <ng-container *ngIf="cartCount > 0; else emptyCart">
                                        {{ cartCount }} {{ cartCount === 1 ? 'item' : 'items' }}
                                    <div class="right-amount-carts">
                                        &nbsp;· ₹{{ cartGrandTotal + shippingCharges | number:'1.2-2' }}
                                    </div>
                                    </ng-container>
                                    <ng-template #emptyCart>
                                    Empty
                                    </ng-template>
                                </div>

                        </div>
                        </button>
                        <div class="wallet-tooltip" *ngIf="!isMobile" style="padding: 0;bottom: -50px;">My Cart</div>
                    </div>
                    </div>
                </div>
    
</div>


    </div>
                     
</mat-toolbar>
<div class="search-results-autocomplete" *ngIf="submitted">
    <div class="table-container mat-elevation-z8">
        <div class="page-title" fxLayout="row" fxLayoutAlign="space-between center">
            <span class="mat-headline text-left m-0 p-12" fxLayout="column" fxLayoutAlign="center start">Search
                Results</span>
            <div class="close-btn text-right p-12 pt-0 pr-8" fxLayout="column" fxLayoutAlign="center end" (click)="closeSearchResults()">
                <mat-icon>close</mat-icon>
            </div>
        </div>
        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
        <table class="clickable" mat-table [dataSource]="searchSource" matSort>
            <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> <strong>ORDER ID</strong> </th>
                <td mat-ripple mat-cell *matCellDef="let row"> <strong>{{row.orderId}}</strong> </td>
            </ng-container>

            <ng-container matColumnDef="registration">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> <strong>VEHICLE</strong> </th>
                <td mat-ripple mat-cell *matCellDef="let row">
                    <strong>{{row.registration | uppercase}}</strong>
                    <div><small>{{row.vehicle | uppercase}}</small> (<small>{{row.fuelType | lowercase}}</small>)</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="orderStartTime">
                <th fxHide.lt-md mat-header-cell *matHeaderCellDef mat-sort-header> <strong>APPOINTMENT</strong> </th>
                <td fxHide.lt-md mat-ripple mat-cell *matCellDef="let row">
                    {{row.orderStartTime == '' ? '-' : row.orderStartTime}}
                </td>
            </ng-container>

            <ng-container matColumnDef="orderEndTime">
                <th fxHide.lt-md mat-header-cell *matHeaderCellDef mat-sort-header> <strong>EXPECTED DELIVERY</strong>
                </th>
                <td fxHide.lt-md mat-ripple mat-cell *matCellDef="let row">
                    {{row.orderEndTime == '' ? '-' : row.orderEndTime}}
                </td>
            </ng-container>

            <ng-container matColumnDef="grandTotal">
                <th fxHide.lt-sm mat-header-cell *matHeaderCellDef mat-sort-header> <strong>AMOUNT</strong> </th>
                <td fxHide.lt-sm mat-ripple mat-cell *matCellDef="let row">
                    {{row.grandTotal == 0 ? '-' : row.grandTotal | currency:"&#8377; "}}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> <strong>STATUS</strong> </th>
                <td mat-ripple mat-cell *matCellDef="let row">
                    <mat-chip-list>
                        <mat-chip class="{{row.status}} mat-chip mat-standard-chip mat-chip-selected" selected [innerHTML]="row.status"></mat-chip>
                    </mat-chip-list>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="searchOrdersColumns;sticky: false"></tr>
            <tr mat-row *matRowDef="let row; columns: searchOrdersColumns;" (click)="openDetails(row.orderId)"></tr>
        </table>
        <div *ngIf="noData && !loading">
            <div class="message-box error mt-16 text-center font-weight-700">
                No Data to display
            </div>
        </div>
        <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
    </div>
</div>
<div class="notify_overlay" *ngIf="showNotifaction" #_eref>
    <button class="cls_btn" (click)="closeNotification()"><i class="material-icons">
        close
        </i></button>
    <div class="notify_cotainer">
        <ul *ngIf="!noNotification">
            <li *ngFor="let notifyMsg of notificationData" (click)="confirmedOrderDetails(notifyMsg.orderId)">{{notifyMsg.message}} </li>
        </ul>
        <p class="notification" *ngIf="noNotification"> No Data to display </p>
    </div>
    <div class="pagination_sec" *ngIf="showPaginations">
        <button (click)="prevNotify()" [disabled]="showPrevButton">Previous</button>
        <button (click)="nextNotify()">Next</button>
    </div>
</div>

<mat-sidenav-container>
    <div class="overlay" [class.visible]="sidebarOpen" (click)="closeSidebar()" ></div>
    <div [class.sidebar-open]="sidebarOpen" class="mywallet-sidebar" *ngIf="sidebarOpen">
        <div class="wallet-sidebar-content">
            <div class="wallet-heading">
                <mat-icon class="wallet-mat" (click)="closeSidebar()" >arrow_back</mat-icon>
                <h3 >Autoverse Wallet </h3>
                <button class="know-more-btn" (click)="openDrawer()">KNOW MORE</button>
            </div>
            <div class="balance-section">
                <div class="balance-details">
                    <div class="balance-text">Total Wallet Balance</div>
                    <div class="balance-amount">₹ {{ walletInfoData.totalAmount}}</div>
                </div>
                <div class="balance-icon">
                    <div class="wallet-icon-bg">
                        <img src="../../../../assets/images/wallet/wallet_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg" alt="wallet icon">
                    </div>
                </div>

            </div>
            <div class="transaction-list-heading" *ngIf="walletInfoData?.transactions?.length>0">Wallet Transactions</div>
             <div class="transaction-list" *ngIf="walletInfoData?.transactions?.length>0">
                <div 
                class="transaction" 
                *ngFor="let transaction of walletInfoData.transactions; let i = index">
                <div class="transaction-header">
                  <div style="    display: flex; align-items: center;">
                        <span class="transaction-type">
                          <img src="../../../../assets/images/svg.svg" />
                        </span>
                        <div style="display: grid;">
                          <span style="color: black; font-size: 20px;"
                            class="transaction-type-text"
                            [ngClass]="{
                              'amount-debit': transaction.type === 'debit' || transaction.type === 'gift_card_debit',
                              'amount-credit': transaction.type === 'credit'
                            }"
                          >
                            ₹{{ transaction.amount }}
                          </span>
                          <span style="color: #555;">{{ transaction.title }} </span>
                        </div>
                  </div>
                   <!-- <span class="transaction-amount">
                    {{ transaction.type === 'debit' || transaction.type === 'gift_card_debit' ? 'Paid To' : 'Received From' }}
                  </span> -->
                  <!-- <span  class="transaction-status-badge">  Partially Used</span> -->
                  <span class="transaction-status-badge"  [ngClass]="{
                        'status-unused': transaction.remainingAmount === transaction.amount,
                        'status-fully-used': transaction.remainingAmount === 0,
                        'status-partially-used': transaction.remainingAmount > 0 && transaction.remainingAmount < transaction.amount }"    >
                    {{
                        transaction.remainingAmount === transaction.amount
                        ? 'Unused'
                        : transaction.remainingAmount === 0
                        ? 'Fully Used'
                        : 'Partially Used'
                    }}
                </span>

                </div>
                <div style="display: flex;padding: 15px 10px 5px 14px;justify-content: space-between;">
                    <div class="transaction-date">
                      <span> Credited on {{ transaction.createdOn | date:'MMM dd, yyyy, hh:mm a':'GMT+1060' }}</span>
                    </div>
                  <span
                      class="toggle-icon"
                      (click)="toggleDetails(i)"
                      style="cursor: pointer;"
                    >
                      <mat-icon>
                        {{ openedIndex === i ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                    </span>
                </div>
                <div class="transaction-details">
                <div class="transaction-info-header">
                    <div class="transaction-title">
                    <ng-container *ngIf="transaction.remainingAmount > 0; else noAmount">
                         ₹{{ transaction.remainingAmount }} remaining 
                    </ng-container>
                    <ng-template #noAmount>
                        <span style="color: #555;">No amount left to expire</span>
                    </ng-template>
                    </div>
                </div>

                <div class="transaction-status" *ngIf="transaction.type !== 'debit'">
                    <ng-container *ngIf="transaction.expired; else expiresOnTemplate">
                    <span style="color: #F44336;">
                        Expired on {{ transaction.expiresOn | date: 'MMM dd, yyyy' : 'GMT+1060' }}
                    </span>
                    </ng-container>
                    <ng-template #expiresOnTemplate>
                    <span style="color: #c77a06;">
                        Expires on {{ transaction.expiresOn | date: 'MMM dd, yyyy' : 'GMT+1060' }}
                    </span>
                    </ng-template>
                </div>
                </div>

                <!-- Collapsible Content below (HARD CODED) -->
              <div  class="transaction-expanded" *ngIf="openedIndex === i"  >
                <div *ngIf="transaction.usage && transaction.usage.length > 0; else noUsage">
                    <div class="usage-brake">Usage Breakdown</div>

                    <div 
                    *ngFor="let log of transaction.usage" 
                    style="display: flex; align-items: center; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #eee;"
                    >
                    <div class="svg-icon">
                        <img src="../../../../assets/images/i.svg"  />
                        <div>
                        <div style="font-weight:800;">₹{{ log.amount }}</div>
                        <div style="font-size:12px; color:#555;">{{ log.orderNumber }}</div>
                        </div>
                    </div>
                    <div style="font-size:12px; color:#555;">
                        {{ log.createdAt | date: 'MMM dd, yyyy' }}
                    </div>
                    </div>
                </div>
                <ng-template #noUsage>
                    <div style="color: #888; font-size: 13px; padding: 8px 0;">
                    No usage recorded.
                    </div>
                </ng-template>
                </div>

              </div>
  
            </div>
                <div class="wallet-tip-box" *ngIf="walletInfoData?.transactions?.length>0">
                  <span class="wallet-tip-icon">💡</span>
                  <span>
                    Tip: Each wallet credit can be used in multiple transactions. Only unused amounts expire after 30 days.
                  </span>
                </div>
            <div class="transaction-money" *ngIf="walletInfoData?.transactions?.length==0">
                <div class="transaction-heading">Currently You don't have any Wallet Transaction</div> 
                <div class="transaction-sub-heading" >Stay tuned for updates</div>
            </div>
            <div class="redeem-button">
                <div class="redeem" *ngIf="walletInfoData.totalAmount >0" (click)="redeemNow()">Redeem Now</div>
        </div>
        </div>
    </div>
</mat-sidenav-container>


<!-- Bottom Sheet Content -->
<!-- <div class="overlay" [class.visible]="sidebarOpen" (click)="closeDrawer()" ></div> -->
<!-- <div class="wallet-bottom-sheet" [class.show]="isDrawerVisible">
    <button class="close-btn" (click)="closeDrawer()">×</button>
    <img src="../../../../assets/images/gift_images.jpeg" alt="Gift Icon" class="gift-icon">
    {{orderDeliverCredit}}
    <div class="quality-heading">{{ knowMoreHeading || 'No heading available' }}</div>
    <ul>
        <li *ngFor="let point of knowMorePoints; let i = index">
            <label class="point-label">
                <input type="radio" [value]="'option' + (i + 1)" name="walletOption">
                {{ point }}
            </label>
        </li>
    </ul>
</div> -->
<!-- <div class="overlay-isdrawer" [class.visible]="isDrawerVisible" (click)="closeDrawer()" ></div> -->
<!-- <div class="wallet-popup-overlay" *ngIf="isDrawerVisible">
  <img src="../../../../assets/images/gift_images.jpeg" alt="Background Gift Image" class="wallet-background-image" />
        <div class="wallet-bottom-sheet">
            <div class="close-btn-space-div">
                <button class="close-btn" (click)="closeDrawer()"><mat-icon>close</mat-icon></button>
            </div>
        <img src="../../../../assets/images/gift_images.jpeg" alt="Gift Icon" class="gift-icon">
        {{orderDeliverCredit}}
        <div class="quality-heading">{{ knowMoreHeading || 'No heading available' }}</div>
        <ul>
        <li *ngFor="let point of knowMorePoints; let i = index">
            <label class="point-label">
            <input type="radio" [value]="'option' + (i + 1)" name="walletOption">
            {{ point }}
            </label>
        </li>
        </ul>
        </div>
</div> -->
<!-- <div class="overlay" *ngIf="isDrawerVisible" [class.visible]="isPopupVisible" (click)="closeDrawer()"></div> -->
<div class="wallet-bottom-sheet" [class.show]="isDrawerVisible">
  <div class="wallet-image-container">
    <img class="wallet-background-img" src="https://cube.getpitstop.com/stagimages/wallet.jpg" alt="Wallet Background" />
    <button class="close-btn" (click)="closeDrawer()">×</button>
    <div class="wallet-card">
      <div class="logo">
        <img src="assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo" />
        <div class="text">AUTOVERSE</div>
      </div>
      <div class="quality-heading">{{ knowMoreHeading || 'Wallet Rules' }}</div>
      <ul class="rules-list">
  <li *ngFor="let point of knowMorePoints; let i = index">
    <label class="point-label">
      <input type="radio" [value]="'option' + (i + 1)" name="walletOption">
      {{ point }}
    </label>
  </li>
</ul>

<ul class="notes-list">
  <li *ngFor="let note of notes">{{ note }}</li>
</ul>

    </div>
  </div>
</div>


<div #dynamicContainer></div>
<div #searchSidebar></div>
<!-- <app-asp-add-item-sidebar #aspAddItemSidebar></app-asp-add-item-sidebar> -->
<div #wishlistcontainer></div>

<!-- // ==============NETQORK ISSUE CODE============== -->
<!-- <div #networkContainer></div> -->
<!-- // ==============NETQORK ISSUE CODE END============== -->

<ng-container #autoscoreHost></ng-container>
<ng-container #HelpUsKnowHost></ng-container>
<div #intstantorder></div>
